import { FieldType } from './types/custom-worksheet-v2';

export const ROW_SIZES = [50, 100, 200];
export const PREFERRED_LOCALE = 'en-AU';
export const NUMERIC_TYPES = [FieldType.ACCOUNTING, FieldType.MONEY, FieldType.NUMBER, FieldType.PERCENT];
export const PROPERTY_NAME_CHAR_LIMIT = 200;
export const RESTRICTED_SYMBOLS = ['.', '[', ']'];
export const RESTRICTED_KEYWORDS = [
    'item',
    'row',
    'list',
    'list item',
    'section',
    'section group',
    'field',
    'table',
    'summary',
    'properties',
];
